// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonEnums = {
  examStatus: {
    draft: "Draft",
    published: "Published",
    running: "Running",
    ended: "Ended",
    archived: "Archived",
  },
  environmentInstanceStatus: {
    provisioning: "Provisioning",
    ready: "Ready",
    running: "Running",
    evaluated: "Evaluated",
    destroyed: "Destroyed",
    failed: "Failed",
    expired: "Expired",
  },
  questionStatus: {
    draft: "Draft",
    published: "Published",
    archived: "Archived",
  },
  paperStatus: {
    draft: "Draft",
    published: "Published",
    archived: "Archived",
  },
  difficulty: {
    easy: "Easy",
    medium: "Medium",
    hard: "Hard",
  },
  paperType: {
    fixed_manual: "Fixed Paper - Manual",
    fixed_rule: "Fixed Paper - Rule-based",
    differentiated: "Differentiated Paper",
    variant: "Variant Paper",
    adaptive: "Adaptive Paper",
  },
  judgeVerdict: {
    accepted: "Accepted",
    wrong_answer: "Wrong Answer",
    compile_error: "Compile Error",
    pending: "Pending",
    runtime_error: "Runtime Error",
    time_limit_exceeded: "Time Limit Exceeded",
  },
  resultVisibility: {
    hidden: "Hidden",
    after_submit: "Visible after submission",
    after_publish: "Visible after publish",
  },
  answerVisibility: {
    hidden: "Hidden",
    analysis_only: "Analysis only",
    full: "Answers and analysis",
  },
  publishScoreMode: {
    immediate: "Immediate",
    manual: "Manual",
  },
  scoreRecordSource: {
    auto: "Auto Scoring",
    environment: "Environment Scoring",
    judge: "Judge Scoring",
    ai: "AI Scoring",
    manual: "Manual Scoring",
    review: "Review Scoring",
  },
  scoreRecordStatus: {
    valid: "Valid",
    invalid: "Invalid",
    pending: "Pending",
  },
  scoreRecordComments: {
    autoObjectiveScoring: "Automatic objective scoring",
    manualReview: "Manual review",
    flagValidationPassed: "Flag validation passed",
    flagValidationFailed: "Flag validation failed",
    flagValidatedDeferred: "Flag validated at submit (deferred mode)",
    flagValidationFailedDeferred: "Flag validation failed at submit (deferred mode)",
    noFlagSubmitted: "No flag submitted",
    attackDefenseFlagSnapshotMissing: "Attack-defense flag snapshot missing",
    judgeResult: "Judge result",
  },
  questionType: {
    single_choice: "Single Choice",
    multiple_choice: "Multiple Choice",
    judgment: "True or False",
    short_answer: "Short Answer",
    code: "Coding",
    practical: "Practical",
    attack_defense: "Attack & Defense",
  },
  questionTypeShort: {
    single_choice: "Single",
    multiple_choice: "Multiple",
    judgment: "T/F",
    short_answer: "Short",
    code: "Code",
    practical: "Practical",
    attack_defense: "A&D",
    mixed: "Mixed",
  },
  attemptStatus: {
    assigned: "Assigned",
    contract_missing: "Status Missing",
    not_started: "Not Started",
    started: "In Progress",
    submitted: "Submitted",
    graded: "Graded",
    expired: "Expired",
    absent: "Absent",
    cancelled: "Cancelled",
    in_progress: "In Progress",
    abandoned: "Abandoned",
  },
  reviewStatus: {
    pending: "Pending Review",
    completed: "Completed",
  },
  userStatus: {
    active: "Active",
    inactive: "Inactive",
    locked: "Locked",
    disabled: "Disabled",
  },
} as const;
